module.exports = __webpack_public_path__ + "img/retailers-2-c@2x.3ba7976a.jpg";